import { createFileRoute } from '@tanstack/react-router';

import { getEditorialTeamOptions } from '@/module/Author/EditorialTeam';

export const Route = createFileRoute('/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout')({
  loader: async ({ params: { editorialTeamId }, context: { queryClient } }) => {
    const editorialTeam = await queryClient.ensureQueryData(getEditorialTeamOptions(editorialTeamId));

    return {
      editorialTeam,
      crumb: editorialTeam.type === 'JOURNAL' ? editorialTeam.journalName : editorialTeam.publisherName,
    };
  },
});
